import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import state from "./state";

const diagnosestellungModule = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}

export default diagnosestellungModule